import { render, staticRenderFns } from "./BreadCumb.vue?vue&type=template&id=290ecb5e&scoped=true&"
import script from "./BreadCumb.vue?vue&type=script&lang=js&"
export * from "./BreadCumb.vue?vue&type=script&lang=js&"
import style0 from "./BreadCumb.vue?vue&type=style&index=0&id=290ecb5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290ecb5e",
  null
  
)

export default component.exports